import Service from '@ember/service';
import { CorsWorker as Worker } from 'cio/utils/workers';
import { PWBHost } from 'promise-worker-bi';

export enum CIOWorker {
  ProcessAnalysisMetrics = 'process-analysis-metrics',
  TimeGroupAnalysisMetrics = 'time-group-analysis-metrics',
  TotalAnalysisMetrics = 'total-analysis-metrics',
}

export default class WorkersService extends Service {
  private importedWorkers: Partial<Record<CIOWorker, PWBHost>> = {};

  getWorker(worker: CIOWorker): PWBHost {
    let cachedWorker = this.importedWorkers[worker];

    if (cachedWorker != null) {
      return cachedWorker;
    }

    let corsWorker = this.createWorker(worker);
    let newWorker = new PWBHost(corsWorker.getWorker());

    this.importedWorkers[worker] = newWorker;

    return newWorker;
  }

  // In order to create asset chunks for web workers, embroider relies on a
  // combo of the Worker keyword and the path to the worker. If you try to pass
  // the path as a variable, it won't create a chunked asset which will result
  // in an error on the ui eventually. This function acts as an exhaustive
  // pattern match thanks to typescript, the explicit return type, and the
  // CIOWorker enum. There should never be a `default` case here!
  private createWorker(worker: CIOWorker): Worker {
    switch (worker) {
      case CIOWorker.ProcessAnalysisMetrics:
        return new Worker(new URL('../workers/process-analysis-metrics.js', import.meta.url));
      case CIOWorker.TimeGroupAnalysisMetrics:
        return new Worker(new URL('../workers/time-group-analysis-metrics.js', import.meta.url));
      case CIOWorker.TotalAnalysisMetrics:
        return new Worker(new URL('../workers/total-analysis-metrics.js', import.meta.url));
    }
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    workers: WorkersService;
  }
}
